import {useCallback, useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {ProcessoResolver} from "@helpers/ProcessoHelper"
import {Grid, Tab} from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import {TabContext, TabList, TabPanel} from '@material-ui/lab';
import ObjetoPostalService from '@services/ObjetoPostalService';
import {Grafico} from "../../base/Graficos/Grafico";
import CircularProgress from '@material-ui/core/CircularProgress';

export const AcompanhamentoGrafico = () => {
  const processo = ProcessoResolver(useParams().processo);
  const [dadosObjetosPostais, setDadosObjetosPostais] = useState("");
  const [dadosCartoes, setDadosCartoes] = useState("");

  const [loading, setLoading] = useState(true);
  const [loadingCartoes, setLoadingCartoes] = useState(true);

  const [tabValue, setTabValue] = useState("0");

  const carregarDados = useCallback(() => {
    setLoading(true);
    ObjetoPostalService.getDadosGraficosObjetoPostais(processo.id).then((resultado) => {
      setDadosObjetosPostais(resultado.data);
      setLoading(false);

    });
    ObjetoPostalService.getDadosGraficosCartoes(processo.id).then((resultado) => {
      setDadosCartoes(resultado.data);
      setLoadingCartoes(false)
    });

  }, [processo.id]);

  useEffect(() => carregarDados(), [processo, carregarDados]);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };
  return (

      <Paper spacing={2} elevation={1}>
        <Grid item container>
          <Grid item sm={12} lg={12}>
            <TabContext value={tabValue}>
              <TabList onChange={handleChange} indicatorColor="primary" textColor="primary" variant="fullWidth">
                <Tab label="Objeto Postais" value="0"/>
                <Tab label="Cartões" value="1"/>
              </TabList>
              {loading ? (
                <Grid container style={{justifyContent: "center", padding: "12rem" }}>
                  <CircularProgress size={64} />
                </Grid>
              ) : (
              <TabPanel value="0" style={{paddingBottom: "10rem"}}>
                <Grid container>
                  <Grid item xs={12}>
                    <Grafico dados={dadosObjetosPostais} name={"Etapas dos Objetos Postais"}
                             style={{height: '300px', width: '100%'}}/>
                  </Grid>
                  <Grid item xs={12} style={{marginTop: "5rem"}}>
                    <Grafico tipo={'line'} cumulativo={true} dados={dadosObjetosPostais}
                             name={"Etapas dos Objetos Postais - Cumulativo"} style={{height: '300px', width: '100%'}}/>
                  </Grid>
                </Grid>
              </TabPanel>
              )}

              {loadingCartoes ? (
                <Grid container style={{justifyContent: "center", padding: "12rem" }}>
                  <CircularProgress size={64} />
                </Grid>
              ) : (
              <TabPanel value="1" style={{paddingBottom: "10rem"}}>
                <Grid container>
                  <Grid item xs={12}>
                    <Grafico dados={dadosCartoes} name={"Etapas dos Cartões"}
                                style={{height: '300px', width: '100%'}}/>
                  </Grid>
                  <Grid item xs={12} style={{marginTop: "5rem"}}>
                    <Grafico cumulativo={true} dados={dadosCartoes} name={"Etapas dos Cartões - Cumulativo"}
                                style={{height: '300px', width: '100%'}}/>
                  </Grid>
                </Grid>
              </TabPanel>
              )}
            </TabContext>
          </Grid>
        </Grid>
      </Paper>
    )
}
export default AcompanhamentoGrafico;
